import datetimeProvider from "../../../../../providers/datetime.provider";
import { packages } from "../../../../constant/marketing/product.constant";

/**
 * Promo "Escritório Campeão" (tema Copa) — jun/2026.
 *
 * Janelas disjuntas (dia BRT), idênticas às do backend (voucher ESCRITORIOCAMPEAO):
 * 12-13, 17-20 e 23-26/06. Fora delas, getCurrentEvent() não retorna este evento e o
 * marketplace volta ao layout padrão — assim a faixa de brinde e o cupom só aparecem
 * quando o servidor de fato concede o desconto + brinde.
 *
 * Cada entrada de `packages` é um tema consumido pelo PlanCard
 * (components/marketplace/marketplace.packages.component.js):
 *  - `card`       paleta do card (fundo/borda/textos/nome/checks);
 *  - `giftBanner` faixa de brinde no topo (bola + texto);
 *  - `giftItem`   item de brinde na lista de benefícios (presente + texto);
 *  - `couponChip` chip do cupom;
 *  - `cta`        cor do botão de compra.
 *
 * Start entra só no cupom (10% via ESCRITORIOCAMPEAO), sem brinde — por isso
 * recebe apenas `couponChip`, sem `card`/`giftBanner`/`giftItem`.
 */
const COPA_WINDOWS = [
    ["2026-06-12", "2026-06-13"],
    ["2026-06-17", "2026-06-20"],
    ["2026-06-23", "2026-06-26"],
];

const COUPON_CHIP_TEXT = "10% OFF · cupom ESCRITORIOCAMPEAO";

const eventCopa2026Config = {
    key: "copa2026",
    label: "Escritório Campeão",
    initialDate: COPA_WINDOWS[0][0],
    finalDate: COPA_WINDOWS[COPA_WINDOWS.length - 1][1],
    validator: function () {
        const today = datetimeProvider.getDate();
        return COPA_WINDOWS.some(([start, end]) => today.isBetween(start, end, "day", "[]"));
    },
    packages: {
        [packages.start.id]: {
            couponChip: {
                border: "#0C5C37",
                color: "#0C5C37",
                text: COUPON_CHIP_TEXT,
            },
        },
        [packages.premium.id]: {
            name: "Premium Campeão",
            card: {
                background: "#0C5C37",
                border: "#E6B73D",
                secondaryText: "#A9D2BB",
                nameColor: "#F0C94B",
                checkColor: "#F0C94B",
            },
            giftBanner: {
                background: "#E6B73D",
                color: "#3D2E08",
                text: "+2 entregas express de brinde",
            },
            giftItem: {
                background: "#E6B73D",
                color: "#3D2E08",
                text: "Promoção Copa: +2 entregas express grátis (30 dias)",
            },
            couponChip: {
                border: "#E6B73D",
                color: "#F0C94B",
                text: COUPON_CHIP_TEXT,
            },
            cta: {
                background: "#E6B73D",
                color: "#3D2E08",
            },
        },
        [packages.infinity.id]: {
            name: "Infinity Craque",
            card: {
                background: "#0A1130",
                border: "#2F6BE0",
                secondaryText: "#8FB0F2",
                nameColor: "#37D98A",
                checkColor: "#37D98A",
            },
            giftBanner: {
                background: "#1E4FD0",
                color: "#FFFFFF",
                text: "+4 entregas express de brinde",
            },
            giftItem: {
                background: "#1E4FD0",
                color: "#FFFFFF",
                text: "Promoção Copa: +4 entregas express grátis (30 dias)",
            },
            couponChip: {
                border: "#2F6BE0",
                color: "#37D98A",
                text: COUPON_CHIP_TEXT,
            },
            cta: {
                background: "#1E4FD0",
                color: "#FFFFFF",
            },
        },
    },
};

export default eventCopa2026Config;
